<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date"><span class="createTimeItem">下单时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker 
							v-model="orderForm.beginTime"
							type="month"
							placeholder="选择日期"
							name="start-date"
							class="setTimePicker"
							value-format="yyyyMM"
							>
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker 
							v-model="orderForm.endTime"
							type="month"
							placeholder="选择日期"
							name="start-date"
							class="setTimePicker"
							value-format="yyyyMM"
							>
						</el-date-picker>
					</span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="platform-content-box clearfix">
			<div class="platform-content-left fl">
				<div class="data-table-box">
					<common-table ref="CommonTableRef" 
						:tableColumns="tableColumns" 
						:data="dataList" 
						:loading="false"
						:showPage="togglePage"
						:pageConfig="pageConfig"
						@selectionChange="selectionChange"
						@sizeChange="sizeChange"
						>
					</common-table>
				</div>
				<!-- <div class="data-table-box">
					<div class="data-table-warp">
						<div class="data-table-warp-left">
							<div class="data-table">
								<el-table :data="dataList" style="width: 100%" @selection-change="handleSelectionChange" height="500" stripe>
									<el-table-column prop="dateMonthFormatted" label="日期" width="180">
									</el-table-column>
									<el-table-column prop="driverUserGrowth" label="司机用户增长数" width="180">
									</el-table-column>
									<el-table-column prop="ownerUserGrowth" label="货主用户增长数" show-overflow-tooltip>
									</el-table-column>
								</el-table>
							</div>
							<div class="st-order-bottom">
								<div class="page-floote-box clearfix fl" v-show="togglePage">
									<div class="st-page-switch">
										<span class="st-page-prev":class="this.listPage.current<=1?'stDisabled':''"   @click="pagePrev"></span>
										<span class="st-page-current"><input type="text" v-model="listPage.current"></span>
										<span class="st-page-next" :class="listPage.current>=listPage.pages?'stDisabled':''" @click="pageNext"></span>
									</div>
									<el-select v-model="listPage.currentSize" placeholder="请选择" class="st-page-pagers" >
										<el-option
										v-for="item in listPage.sizes"
										:key="item.value"
										:label="item.label"
										:value="item.value">
										</el-option>
									</el-select>
									<div class="st-page-total">/共{{listPage.total}}条</div>
								</div>
							</div>
						</div>
					</div> 
				</div> -->

			</div>
			<div class="data-table-warp-right fr">
				<div id="myChart" ></div>
			</div>
		</div>
	</div>
</template>
<script>
import echarts from 'echarts'
import { mapActions } from 'vuex';

export default {
  	name: 'UserIncrease',
	props: [],
	components: {},
	data(){
		return{
			tableColumns:[
				{
					key:'dateMonthFormatted',
					title:'日期',
					align:'center',
					width:'100'
				},{
					key:'driverUserGrowth',
					title:'司机用户增长数',
					align:'center',
					width:'180'
				},{
					key:'ownerUserGrowth',
					title:'货主用户增长数',
					align:'center',
				},
			],
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
				layout: "total, sizes",
			},
			dataList:[],
			orderForm:{
				beginTime: '', // 下单起始时间  
				endTime: '', // 下单结束时间 
			},
			
			Xdate:[],
			Ydata:[],
			driverUserGrowth:[],//司机
			ownerUserGrowth:[],//货主
			togglePage:false, //是否显示分页
		}
	},
	created() {},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			let Xdate=[];
			let Ydata=[];
			let ownerUserGrowth=[];
			let driverUserGrowth=[];
			this.$server.report.appuserStatisticsPage(orderForm,(res)=>{
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					res.data.records.forEach(item=>{
						Xdate.push(item.dateMonthFormatted)
						Ydata.push(item.driverUserGrowth)
						ownerUserGrowth.push(item.ownerUserGrowth)
						driverUserGrowth.push(item.driverUserGrowth)
					})
					this.Xdate=Xdate;
					this.Ydata=Ydata;
					this.driverUserGrowth=driverUserGrowth;
					this.ownerUserGrowth=ownerUserGrowth;
					if(res.data.total>0){
						this.togglePage=true;
					}
					this.drawLine()
				}
			})
		},
		
		drawLine(){
       	 	// 基于准备好的dom，初始化echarts实例
			let myChart = this.$echarts.init(document.getElementById('myChart'));
			var date=this.Xdate.reverse();
			var ownerUserGrowth=this.ownerUserGrowth.reverse();
			var driverUserGrowth=this.driverUserGrowth.reverse();
			console.log(ownerUserGrowth,driverUserGrowth)
			myChart.setOption({
				title: {
					text: '堆叠区域图'
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				legend: {
					data: [{
							name:'司机',
							icon:'none',
							textStyle:{
								color:'#4A3FAC'
							}
						}, 
						{
							name:'货主',
							icon:'none',
							textStyle:{
								color:'#DD3C3C'
							}
						}],
				},
				toolbox: {
					feature: {
						saveAsImage: {}
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						data: date,
					}
				],
				yAxis: [
					{
						type: 'value',
					}
				],
				series: [
					{
						name: '司机',
						type: 'line',
						stack: '总量',
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0, color: '#2947BD' // 0% 处的颜色
								}, {
									offset: 1, color: '#43D2F0' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						},
						lineStyle:{
							color:'#4A3FAC'
						},
						symbolSize:5,
						data: driverUserGrowth
					},
					{
						name: '货主',
						type: 'line',
						stack: '总量',
						areaStyle: {
							color: {
							type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0, color: '#FF391A' // 0% 处的颜色
								}, {
									offset: 1, color: '#FFB042' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							},
						},
						lineStyle:{
							color:'#DD3C3C'
						},
						data: ownerUserGrowth
					},
					
				]
			})
			
		},
		selectionChange(val) {
			this.multipleSelection = val;
		},
	},
	mounted() {
		this.searchList()
	}
}

</script>
<style scoped>
.query-setting-box {
	display: flex;
	height: auto;
	background: #FFF;
	padding: 18px 8px 0;
	position: relative;
	overflow: hidden;
	font-size: 14px;
	margin-bottom: 8px;
}
.query-setting-box-left{
	flex-grow: 0;
}
.order-query-form-box {
  float: left;
  width: 140px;
  height: auto;
  margin: 0 24px 18px 0;
}
.order-query-form-box-right{
	padding-top: 22px;
	width: 80px;
}

.order-query-form-box label {
  display: block;
  width: 100%;
  height: 22px;
  line-height: 22px;
  color: #383838;
}
.createTimeItem{
	background-color: #FF5B3E;
	color: #fff;
	padding-right: 4px;
}
.createTimeItem i{
	display: inline-block;
	width: 8px;
	height: 12px;
	background: url('../../assets/images/icon_select.png') center no-repeat;
	background-size: 100% 100%;
	margin-left: 12px;
	vertical-align: middle;
}

.order-query-form-box input {
  display: block;
  width: 99%;
  height: 28px;
  line-height: 28px;
  border: 1px solid #DCDCDC;
  border-radius: 3px;
}

.order-query-form-submit {
  display: block;
  width: 80px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #FFF;
  background: #FF5B3E;
  border: 1px solid #FF5B3E;
  border-radius: 3px;
  margin: 0 auto;
}
.platform-content-box{ 
	display: flex;
	justify-content: space-between;
	flex-grow: 1;

}

.platform-content-left{
	/* width: 840px; */
	flex-grow: 1;
	margin-right: 5px;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.data-table {
	margin-bottom: 8px;
	box-sizing: border-box;
}

.data-table-warp-right{
	
	width: 951px;
	box-sizing: border-box;
	padding: 8px;
	background-color: #Fff;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
#myChart{
	width: 100%;
	height: 600px;
}
@media only screen and (max-width: 1366px) {
	.platform-content-left {
		width: 586px;
	}
	.data-table-warp-right {
		width: 660px;
	}
}
</style>
